import { Bento } from "@/components/ui/box";
import type { FactBox } from "@/components/ui/box.schema";
import type { CourseGuide as Guide } from "@/lib/api/courseGuide";
import { guideRead, useGuide } from "./use-guide";

export function CourseGuide({ courseId, teaching }: { courseId: string; teaching: boolean }) {
  const query = useGuide(courseId, teaching);
  const box: FactBox<Guide> = { id: "course-guide", kind: "fact", label: "Course guide", job: "Read how this course works or prepare its private guide.", owner: { system: "imam" },
    fold: "choice", read: guideRead(query), detail: value => value.published ? `Published version ${value.published.revision}` : "Not published yet",
    prose: value => value.published?.overview || "Your teachers publish the guide when it is ready.",
    exits: [{ label: teaching && query.data?.course_status !== "archived" ? "Prepare guide" : "Read guide", visit: `course-guide:${courseId}` }] };
  return <Bento id="course-guide-register" journey="course guide" boxes={[box]} />;
}
